module.exports = __webpack_public_path__ + "img/game-of-khans.d99973b.png";